import * as React from "react";
import CsrfInput from "../../sign-in/CsrfInput";
import Identity from "../model/Identity";
import ImpersonateAction from "../model/ImpersonateAction";
import "./IdentityText.scss";

interface IdentityTextProps {
  identity: Identity;
  impersonateAction: ImpersonateAction;
  pageUrl?: string;
}

export default class IdentityText extends React.Component<IdentityTextProps> {
  static defaultProps = {
    highLightName: false,
  };

  render() {
    const identity = this.props.identity;
    return (
      <>
        {this.props.pageUrl ? (
          <a id="link-to-report" className="identity link" href={this.props.pageUrl}>
            {identity.fullName}
          </a>
        ) : (
          <span className="identity">{identity.fullName}</span>
        )}
        {identity.canBeImpersonated && (
          <form className="identity" method="post" action={this.props.impersonateAction.url}>
            <input type="hidden" name="username" value={identity.email} />
            <CsrfInput csrf={this.props.impersonateAction.csrf} />
            <input
              type="submit"
              className="link"
              value={i18n["Global.Identity.Impersonate"]}
              onClick={(e) => e.stopPropagation()}
            />
          </form>
        )}
      </>
    );
  }
}
